import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {MeshCellFontName} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/cellSettings/MeshCellFont';
import {CellSettingsSubMenu} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/cellSettingsBar/CellSettingsSubMenu';
import {CellSettingsSubMenuKeys} from '@mintdata-wsp/wsp/ui/views/visualDesigner/spreadsheet/header/cellSettingsBar/CellSettingsSubMenuKeys';
import {SheetId} from '@mintdata/mint-kit/api/models/Identifiers';
import bind from 'bind-decorator';

import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./FontName.less');
const cx = classnames.bind(styles);

export interface IFontNameProps
{
    focusedSheetId:SheetId;

    selected?:MeshCellFontName;
    onChange?:(fontName:MeshCellFontName, closePopover?:boolean) => void;

    onShow?:() => void;
    onHide?:() => void;
}

export interface IFontNameState
{
}

export class FontName extends React.Component<IFontNameProps, IFontNameState>
{
    public render()
    {
        const {focusedSheetId, onShow, onHide, selected} = this.props;

        const fonts = Object.values(MeshCellFontName).sort();

        return (
            <CellSettingsSubMenu
                focusedSheetId={focusedSheetId}
                className={cx('base')}
                onShow={onShow}
                onHide={onHide}
            >
                <CellSettingsSubMenuKeys
                    data={fonts}
                    selected={selected}
                    onChange={this._onChange}
                >
                    {fonts.map((fontName:MeshCellFontName) =>
                    {
                        const itemStyle:React.CSSProperties = {fontFamily: `"${fontName}", Arial, sans-serif`};

                        const isSelected = fontName === selected;

                        return (
                            <div
                                key={fontName}
                                className={cx('item', {isSelected})}
                                onClick={() => this._onChange(fontName, true)}
                                style={itemStyle}
                            >
                                <div className={cx('menuItemIcon')}>
                                    {
                                        isSelected &&
                                        <MDIcon
                                            name={MDIcons.common.Checkmark}
                                            size={MDIconSize.medium16}
                                            className={cx('icon')}
                                        />
                                    }
                                </div>
                                {fontName}
                            </div>
                        );
                    })}
                </CellSettingsSubMenuKeys>
            </CellSettingsSubMenu>
        );
    }

    @bind
    private _onChange(fontName:MeshCellFontName, closePopover:boolean = true):void
    {
        const {onChange} = this.props;
        onChange && onChange(fontName, closePopover);
    }
}
